<template>
  <div>
    <van-cell-group>
      <van-field
        v-model="appoint.username"
        clearable
        label="姓名"
        placeholder="请输入姓名"
      />

      <van-field
        v-model="appoint.tel"
        type="tel"
        label="手机号"
        placeholder="请输入手机号"
      />
      <van-cell
        title="性别"
        is-link
        :value="sex_value"
        @click="chooseSex"
      />
      <van-field
        v-model="appoint.age"
        clearable
        label="年龄"
        type="number"
        placeholder="请输入年龄(非必填)"
      />

      <van-cell
        title="预约日期"
        is-link
        :value="date_value"
        @click="showDateTime"
      />
      <van-cell
        title="预约时间"
        is-link
        :value="time_value"
        @click="showTime"
      />
      <van-cell
        title="医生"
        is-link
        :value="doctor_name"
        @click="chooseDoctor"
      />
      <van-cell
        title="预约类型"
        is-link
        :value="type_value"
        @click="chooseType"
      />
      <van-cell
        title="描述"
        is-link
        :value="desc_value"
        @click="chooseDesc"
      />
      <van-field
        v-if="show_other_desc"
        v-model="other_desc"
        placeholder="请输入其他描述"
      />
    </van-cell-group>
    <div style="padding: 10px;">
      <van-button
        type="primary"
        size="large"
        @click="addNew"
      >确定</van-button>
    </div>

    <!--日期-->
    <van-popup
      v-model="date_show"
      position="bottom"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        @cancel="date_show = false"
        @confirm="onDateChange"
      />
    </van-popup>

    <!--时间-->
    <van-popup
      v-model="time_show"
      position="bottom"
    >
      <van-picker
        :columns="timeColumns"
        @cancel="time_show = false"
        @confirm="onTimeChange"
        :show-toolbar="true"
      />
    </van-popup>
    <!--医生-->
    <van-popup
      v-model="doctor_show"
      position="bottom"
    >
      <van-picker
        :columns="doctorsColumns"
        @cancel="doctor_show = false"
        @confirm="onDoctorChange"
        :show-toolbar="true"
      />
    </van-popup>
    <!--性别-->
    <van-popup
      v-model="sex_show"
      position="bottom"
    >
      <van-picker
        :columns="sexColumns"
        :default-index="sexIndex"
        @cancel="sex_show = false"
        @confirm="onSexChange"
        :show-toolbar="true"
      />
    </van-popup>
    <!--类型-->
    <van-popup
      v-model="type_show"
      position="bottom"
    >
      <van-picker
        :columns="typeColumns"
        @cancel="type_show = false"
        @confirm="onTypeChange"
        :show-toolbar="true"
      />
    </van-popup>
    <!--描述-->
    <van-popup
      v-model="desc_show"
      position="bottom"
    >
      <van-picker
        :columns="descColumns"
        @cancel="desc_show = false"
        @confirm="onDescChange"
        :show-toolbar="true"
      />
    </van-popup>
  </div>
</template>

<script>
import dayjs from "dayjs";
import config from "@/config";
import TimeMixins from "@/mixins/time";
export default {
  name: "app",
  mixins: [TimeMixins],
  data() {
    return {
      radio: 1,
      sexIndex: 0,
      doctor_name: "请选择",
      sexColumns: ["男", "女"],
      typeColumns: ["初诊", "复诊"],
      descColumns: [],
      czColumns: [
        "取模",
        "修牙",
        "洗牙",
        "拔牙",
        "检查",
        "疼痛",
        "试样",
        "其他"
      ],
      fzColumns: [
        "全口修复",
        "半口修复",
        "活动修复",
        "固定修复",
        "根管治疗",
        "种植"
      ],
      doctorsColumns: [],
      show: false,
      empNo: "",
      doctor_show: false,
      sex_show: false,
      type_show: false,
      desc_show: false,
      date_show: false,
      doctors: [],
      currentTime: `${new Date().getHours()}:${new Date().getMinutes()}`,
      show_other_desc: false,
      other_desc: "",
      type_value: "请选择",
      desc_value: "请选择",
      sex_value: "请选择",
      date_value: "请选择", // 日期
      time_value: "请选择", // 时间
      reDate: "",
      reTime: "",
      remarkType: "",
      baseUrl: "/",
      appoint: {
        username: "",
        tel: "",
        age: "",
        no: ""
      },
      minDate:
        new Date().getHours() >= 17
          ? new Date(
              dayjs()
                .add(1, "day")
                .format()
            )
          : new Date(),
      currentDate:
        new Date().getHours() >= 17
          ? new Date(
              dayjs()
                .add(1, "day")
                .format()
            )
          : new Date()
    };
  },
  components: {},
  mounted() {
    // localStorage.setItem("openid", config.openid);
    // this.$API.post('/wechat_userinfos', {
    //   code: '1212',
    // })

    let recent_id = localStorage.recent_id || "";
    if (!recent_id) {
      return;
    }
    this.$API.get(`/reserves/${recent_id}`).then(data => {
      this.detail = data.data;
      this.appoint = {
        username: this.detail.cname,
        age: this.detail.age,
        tel: this.detail.telno
      };
      this.sex_value = this.detail.sex;
      this.sexIndex = this.detail.sex == "男" ? 0 : 1;
    });
  },
  methods: {
    // 新增
    addNew() {
      let { username, tel, no, age } = this.appoint;

      if (tel.length === 8 || tel.length === 11) {
        if (tel.length === 11) {
          let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;

          if (!valid_rule.test(tel)) {
            return this.$toast("手机号码错误");
          }
        }
      } else {
        if (tel.length != 0) {
          return this.$toast("电话号码不符合要求!");
        }
      }

      if (!this.type_value) {
        return this.$toast("请选择预约类型");
      }
      if (!this.reDate) {
        return this.$toast("请选择预约日期");
      }
      // localStorage.name = username;
      // localStorage.tel = tel;
      let params = {
        openid: localStorage.openid,
        cname: username,
        telno: tel,
        age: age,
        sex: this.sex_value || "男",
        empNo: this.empNo,
        reType: this.type_value,
        reDate: this.reDate,
        reTime: this.reTime,
        remark: this.remarkType === "other" ? this.other_desc : this.desc_value
      };

      // console.log(params);
      this.$API.post("/reserves", params).then(data => {
        if (data.code != 0) {
          return this.$toast(data.msg);
        } else {
          this.$toast("预约成功");
          let id = data.data.id;
          localStorage.recent_id = id;
          setTimeout(() => {
            this.$router.push("/appoint_details?id=" + id);
          }, 600);
        }
      });
    },
    // 选择医生-> 根据预约日期和时间
    chooseDoctor() {
      if (!this.reDate) {
        return this.$toast("请先选择预约日期");
      }
      if (!this.reTime) {
        return this.$toast("请选择预约时间");
      }

      this.$API
        .get("/doctors/usable_doctor", {
          rdate: this.reDate,
          rtime: this.reTime
        })
        .then(data => {
          if (data.code != 0) {
            this.$toast(data.msg);
          } else {
            this.doctor_show = true;
            this.doctors = data.data;
            this.doctorsColumns = data.data.map(item => item.doctorName);
          }
        });
    },
    onSexChange(value, index) {
      this.sex_value = value;
      this.sex_show = false;
    },
    chooseSex() {
      this.sex_show = true;
    },
    chooseType() {
      this.type_show = true;
    },
    chooseDesc() {
      this.desc_show = true;
    },
    onDescChange(value, index) {
      if (value === "其他") {
        this.remarkType = "other";
        this.show_other_desc = true;
        // this.remark = this.other_desc;
      } else {
        this.remarkType = "no-other";
        this.show_other_desc = false;
        // this.remark = value;
      }
      this.desc_value = value;
      this.desc_show = false;
    },
    onTypeChange(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      this.desc_value = "请选择";

      this.descColumns = value === "初诊" ? this.czColumns : this.fzColumns;

      this.type_show = false;
      this.type_value = value;
    },
    onDateChange(value) {
      console.log(value);
      let date = dayjs(value).format("YYYYMMDD");
      let format_date = dayjs(value).format("YYYY-MM-DD");
      this.date_show = false;
      this.date_value = format_date;
      this.reDate = date;
    },
    onDoctorChange(value) {
      // console.log(value);
      this.doctor_name = value;
      let selectedDoctors = this.doctors.find(
        item => item.doctorName === value
      );
      this.empNo = selectedDoctors.empNo;
      console.log(selectedDoctors);
      this.doctor_show = false;
    },
    showTime() {
      this.time_show = true;
    },
    showDateTime() {
      this.date_show = true;
    },
    confirmAppointTime(value) {
      // let date = new Date(value);
      alert(value);
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
